
// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class AdvanceService extends BaseApi {


    constructor(){
        super();
    }

    async getSelect(business, customAgent)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/customs-agents/${customAgent}/advances`)
        .catch(this.handleErrorResponse)
    }
    async getSelectCompensations(business, customAgent)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/customs-agents/${customAgent}/compensations`)
        .catch(this.handleErrorResponse)
    }

    async list(business, filter)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/customs-agents/advances${filter}`)
        .catch(this.handleErrorResponse);
    }

    async get(business, slug)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/customs-agents/advances/${slug}`)
        .catch(this.handleErrorResponse);
    }


    async store(business, data)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/customs-agents/advances`, data)
        .catch(this.handleErrorResponse);
    }

    async update(business, slug, data)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/customs-agents/advances/${slug}/update`, data)
        .catch(this.handleErrorResponse);
    }


    async delete(business, slug)
    {
        return this.http.delete(`${this.baseUrl}/business/${business}/customs-agents/advances/${slug}`)
        .catch(this.handleErrorResponse);
    }


    async getByCustomAgentClient(business, customs_agent_id, customer_id)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/customs-agents/advances/customs-agents-customers`, {customs_agent_id, customer_id})
        .catch(this.handleErrorResponse);
    }
}